import styled from "../../../../config/emotion";
import { StyledCompProps } from "../../../../globalTypes/theme";

export const OrderButton = styled.button<StyledCompProps & { active: boolean }>`
  border: none;
  background: white;
  line-height: 1px;
  display: block;
  text-align: center;
  color: ${({ theme, active }) =>
    active ? theme.colors.secondaryColor : theme.colors.primaryColor};

  svg {
    font-size: 1.2em;
    text-align: center;
    transform: ${({ active }) => (active ? "scale(1.45)" : "")};
  }

  &:focus {
    outline: none;
  }
`;

export const MobileBtnsContainer = styled.div`
  display: flex;
  gap: 0.4rem;
`;

export const OrderButtonMobile = styled.button<{ active: boolean }>`
  --bg-color: ${({ active, theme }) =>
    active ? "#fff" : theme.colors.secondaryColor};
  --icon-color: ${({ active, theme }) =>
    !active ? "#fff" : theme.colors.secondaryColor};

  width: 3.5rem;
  height: 2rem;

  border-radius: 5px;
  border: 2px solid ${({ theme }) => theme.colors.secondaryColor};

  background-color: var(--bg-color);

  svg {
    position: relative;
    top: -0.3rem;
    fill: var(--icon-color);
    font-size: 2rem;
  }
`;
